import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OrderHistoryModal = ({ isOpen, onClose, orderHistory, onReorder }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="History" size={20} color="var(--color-primary)" />
            </div>
            <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">Order History</h2>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center hover:bg-muted rounded-lg transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-4 md:p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {orderHistory?.length === 0 ? (
            <div className="text-center py-12">
              <Icon name="ShoppingBag" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
              <p className="text-muted-foreground text-sm md:text-base">No previous orders found</p>
            </div>
          ) : (
            <div className="space-y-4">
              {orderHistory?.map((order) => (
                <div key={order?.id} className="bg-muted/50 rounded-lg p-4 md:p-5">
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-sm md:text-base font-semibold text-foreground">
                          Order #{order?.id}
                        </span>
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          order?.status === 'Delivered' ?'bg-success/10 text-success' :'bg-warning/10 text-warning'
                        }`}>
                          {order?.status}
                        </span>
                      </div>
                      <p className="text-xs md:text-sm text-muted-foreground">{order?.date}</p>
                    </div>
                    <span className="text-base md:text-lg font-bold text-primary whitespace-nowrap">
                      SSP {order?.total?.toLocaleString()}
                    </span>
                  </div>

                  <div className="space-y-2 mb-3">
                    {order?.items?.map((item, index) => (
                      <div key={index} className="flex justify-between text-sm md:text-base">
                        <span className="text-foreground">{item?.quantity}x {item?.name}</span>
                        <span className="text-muted-foreground">SSP {item?.price?.toLocaleString()}</span>
                      </div>
                    ))}
                  </div>

                  <Button
                    variant="outline"
                    size="sm"
                    iconName="RotateCcw"
                    iconPosition="left"
                    onClick={() => onReorder(order)}
                    fullWidth
                  >
                    Reorder
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryModal;